import { Container } from 'react-bootstrap';
import { Outlet } from 'react-router-dom';
import { ApiConfiguration } from '../../features/apiReference/apiReferenceSlice';
import Sidebar from './Sidebar/Sidebar';

const DocumentationLayout = ({ apiConfiguration }: { apiConfiguration: ApiConfiguration }) => {
    return (
        <>
            <Container fluid className="vh-100 g-0">
                <div className="d-flex flex-row">
                    <div className="d-flex flex-column position-fixed" style={{ zIndex: 20 }}>
                        <Sidebar apiConfiguration={apiConfiguration}></Sidebar>
                    </div>
                    <div className="d-flex flex-column vh-10 outlet-container w-100">
                        <Outlet />
                    </div>
                </div>
            </Container>
        </>
    )
}

export default DocumentationLayout